/*
 *Utility class to hold parameters for building a URL call to the IPS Services
 */
define(function(require) {
	const $ = require('jquery');
	const _ = require('underscore');
	var urlParameters =	function(){
		this._fieldMappings = [];
		this._extendedFilter = {};
		this._orderBy = {};
		this._select = [];
		this._page = {};
		this._filter = [];
		this._passThroughString = '';
		this._passThroughObject = {};
	}
	$.extend(urlParameters.prototype,{
		addMapping: function(svcName, appName) {
			if (svcName && appName) {
				this._fieldMappings.push({
					svcName: svcName,
					appName: appName
				});
			}
		},
		setMapping: function(Mapping) {
			for (var i = 0; i < Mapping.length; i++) {
				this.addMapping(Mapping[i].svcName, Mapping[i].appName);
			};
		},
		clearMapping: function() {
			this._fieldMappings = [];
		},
		//extended filter will generally come from the filter view,
		//so not doing anything to allow setting individual criteria one at a time.
		//Can revisit if necessary.
		//resets page
		setExtendedFilter: function(filter) {
			//extend using a deep copy (the true part) to sever any references
			this._extendedFilter = $.extend(true, {}, filter);
			this.clearPage();
		},
		clearExtendedFilter: function() {
			this._extendedFilter = {};
		},
		//if you pass in only a property, the direction will be set to ascending automatically.
		//if you pass in the same property again, no direction, it will flip the direction
		//if you pass in both a property and a direction, it will set both.
		//as long as something is set, the page is cleared out.
		setOrderBy: function(property, direction) {
			if (property) {
				if (!direction) {
					if (property === this._orderBy.property) {
						//setting it to the same proprty, flip the direction
						this._orderBy.direction == (this._orderBy.direction === 'asc') ? 'desc' : 'asc';
						this.clearPage();
					} else {
						//set the property, with a direction of asc.
						this._orderBy = {
							property: property,
							direction: 'asc'
						}
						this.clearPage();
					}
				} else if (direction === 'desc' || direction === 'asc') {
					this._orderBy = {
						property: property,
						direction: direction
					}
					this.clearPage();
				}
			}
		},
		clearOrderBy: function() {
			this._orderBy = {};
		},
		addSelect: function(property) {
			if (property) {
				this._select.push(property);
			}
		},
		setSelect: function(properties) {
			for (var i = 0; i < properties.length; i++) {
				this.addSelect(properties[i]);
			}
		},
		clearSelect: function() {
			this._select = [];
		},
		setPage: function(start, max, extendedPage) {
			var newPage = {};
			if (start && start >= 0 && max && max > 0) {
				newPage.start = start;
				newPage.max = max;
			}
			if (extendedPage && extendedPage.property
				&& extendedPage.max && extendedPage.max > 0) {
				this._page = [newPage, {
					property: extendedPage.property,
					max: extendedPage.max
				}];
			} else {
				this._page = newPage;
			}
		},
		nextPage:function(){
			if(this._page && this._page.start && this._page.max){
				this._page.start+=this._page.max;
			}
		},
		clearPage: function() {
			if(this._page && this._page.start && this._page.max){
				this._page.start == 1;
			} else {
				this._page = {};
			}
		},
		addFilter: function(filter) {
			if (filter && filter.property) {
				var newFilter = {
					property: filter.property,
					value: filter.value
				};
				if (filter.operator) {
					newFilter.operator = filter.operator;
				}
				this._filter.push(newFilter);
				this.clearPage();
			}
		},
		setFilter: function(filters) {
			for (var i = 0; i < filters.length; i++) {
				this.addFilter(filters[i]);
			};
		},
		clearFilter: function() {
			this._filter = [];
		},
		setPassThrough: function(passThrough,value,excludedDataType) {
			if(value !== undefined){
				this._passThroughObject[passThrough] = value;
				if (_.isArray(excludedDataType)){
					this._passThroughObject['excludedDataType'] = excludedDataType;
				}
			} else if (passThrough) {
				this._passThroughString = passThrough;
			}

		},
		clearPassThrough: function(id) {
			if ( id ){
				if ( this._passThroughObject[id]){
					delete this._passThroughObject[id];
				}
			}
			else {
				this._passThroughString = '';
				this._passThroughObject = {};
			}
		},
		resetAllParameters: function() {
			this.clearMapping();
			this.clearSelect();
			this.clearOrderBy();
			this.clearPage();
			this.clearFilter();
			this.clearExtendedFilter();
			this.clearPassThrough();
		},
		//return a copy of all the url parameters
		getUrlParameters: function() {
			return $.extend(true, {}, {
				fieldMappings: this._fieldMappings,
				orderBy: this._orderBy,
				select: this._select,
				page: this._page,
				filter: this._filter,
				extendedFilter: this._extendedFilter,
				passThroughString: this._passThroughString,
				passThroughObject: this._passThroughObject
			});
		}
	});
	return urlParameters;
});
